import { createSlice } from '@reduxjs/toolkit'
import { getActiveFilters } from 'utils/helpers'

const initialState = {
  activeFilters: [] as string[],
  tableFilters: {
    search: '',
    adjustment_type: '',
    student: '',
  },
}

export const adjustmentsUI = createSlice({
  name: 'adjustmentsUI',
  initialState: initialState,
  reducers: {
    setSearch: (state, { payload }) => {
      state.tableFilters.search = payload
    },
    setAdjustmentType: (state, { payload }) => {
      state.tableFilters.adjustment_type = payload
    },
    setStudent: (state, { payload }) => {
      state.tableFilters.student = payload
    },
    trackActiveFilters: (state: any) => {
      state.activeFilters = getActiveFilters(initialState.tableFilters, state)
    },
    clearAllFilters: (state: any) => {
      state.tableFilters = initialState.tableFilters
      state.activeFilters = []
    },
  },
})

export const {
  setSearch,
  setAdjustmentType,
  setStudent,
  trackActiveFilters,
  clearAllFilters,
} = adjustmentsUI.actions

export default adjustmentsUI.reducer
